import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import {
  openTemplateModal,
  changeSearch,
} from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import useDebounce from "app/hooks/useDebounce";

const useQuickTextTemplateTable = () => {
  const dispatch = useDispatch();
  const { searchText } = useSelector((state) => state.quickTextTemplate);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [search, setSearch] = useState("");

  const handleRowClick = (rowData) => {
    const selectedTemplate = Object.assign({}, rowData);

    dispatch(
      openTemplateModal({
        selectedTemplate,
        showModal: true,
        modalTitle: "Update Quick Text",
      })
    );
  };

  const onSearchChange = useDebounce((value) => {
    setSearch(value || undefined);
    dispatch(changeSearch(value));
  }, 1600);

  return {
    columnFilters,
    handleRowClick,
    pagination,
    sorting,

    setPagination,
    setSorting,
    setColumnFilters,

    search,
    onSearchChange,
    searchText,
  };
};

export default useQuickTextTemplateTable;
